module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.loading) ? _c('prb-loading') : _vm._e(), _vm._v(" "), (_vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout text-xs-center",
    staticStyle: {
      "min-height": "70vh"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-5 white",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "title white"
  }, [_c('b', [_c('v-icon', {
    staticStyle: {
      "margin-bottom": "5px",
      "margin-right": "3px"
    }
  }, [_vm._v("error_outline")]), _vm._v("\n              Error: Data not found")], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.compound && _vm.compound2 && !_vm.loading && !_vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target_layout__content elevation-1"
  }, [(_vm.nameT.length && _vm.nameC.length) ? _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-title"
  }, [_vm._v("\n                " + _vm._s(_vm.nameT) + " | " + _vm._s(_vm.nameC) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('prb-compound-top', {
    attrs: {
      "compound": _vm.compound,
      "compound2": _vm.compound2
    }
  })], 1)])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24b3c714"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrbSingleCompoundSynopsis.vue
// module id = 554
// module chunks = 1